
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    canAdd: {
      type: Boolean,
      required: true
    },
    canRemove: {
      type: Boolean,
      required: true
    }
  },

  emits: {
    addAction: () => true,
    removeAction: () => true
  },

  setup (_, { emit }) {
    const onClickedAddButton = () => {
      emit('addAction')
    }

    const onClickedRemoveButton = () => {
      emit('removeAction')
    }

    return {
      onClickedAddButton,
      onClickedRemoveButton
    }
  }
})
